import * as React from 'react';

/** Matches Tailwind's `md` breakpoint (768px) — the threshold where the table
 *  switches from the mobile carousel to the desktop layout. */
const DESKTOP_QUERY = '(min-width: 768px)';

/**
 * Returns `true` when the viewport is at or above the `md` breakpoint.
 *
 * Defaults to `false` on the server and on the first render (before the
 * media query fires) so hydration is consistent with SSR output.
 */
export function useIsDesktop(): boolean {
  const [isDesktop, setIsDesktop] = React.useState(false);

  React.useEffect(() => {
    if (typeof window === 'undefined') return;

    const mql = window.matchMedia(DESKTOP_QUERY);
    setIsDesktop(mql.matches);

    const handler = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isDesktop;
}
